import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue-demi';
import type { FormData } from './types';
import FormBuilder from './FormBuilder.vue';
import FormSuccess from './FormSuccess.vue';
import FormError from './FormError.vue';
import FormLoading from './FormLoading.vue';
import { createFormsApi } from '../api/formsApi';
import useTheme from '../composables/useTheme';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormContainer',
  props: {
    formId: null,
    successMessage: null
  },
  emits: ["submit", "submit-success", "submit-error"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', values: Record<string, any>): void;
  (e: 'submit-success'): void;
  (e: 'submit-error', error: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  formId: string;
  successMessage?: {
    title: string;
    description: string;
    buttonText: string;
  };
};



const defaultSuccessMessage = {
  title: 'Форма успешно отправлена',
  description: 'Спасибо за ваше время и внимание!',
  buttonText: 'Отправить еще раз',
};

const config = useTheme();
const baseUrl = computed(() => config?.baseUrl || '');
const formsApi = createFormsApi({ baseUrl: baseUrl.value });

const successMessage = computed(
  () => props.successMessage || defaultSuccessMessage,
);



const formData = ref<FormData | null>(null);
const isLoading = ref(false);
const error = ref<string | null>(null);
const isSubmitting = ref(false);
const showSuccessAlert = ref(false);

const loadForm = async () => {
  isLoading.value = true;
  error.value = null;

  try {
    formData.value = await formsApi.getFormSchema(props.formId);
  } catch (e) {
    error.value = e instanceof Error ? e.message : 'Failed to load form';
  } finally {
    isLoading.value = false;
  }
};

const handleSubmit = async (values: Record<string, any>) => {
  if (!formData.value) return;

  isSubmitting.value = true;
  error.value = null;
  emit('submit', values);

  try {
    await formsApi.submitForm(props.formId, values);
    showSuccessAlert.value = true;
    emit('submit-success');
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : 'Failed to submit form';
    error.value = errorMessage;
    emit('submit-error', errorMessage);
  } finally {
    isSubmitting.value = false;
  }
};

const resetForm = () => {
  showSuccessAlert.value = false;
  error.value = null;
};

onMounted(() => {
  loadForm();
});

return { __sfc: true,props, defaultSuccessMessage, config, baseUrl, formsApi, successMessage, emit, formData, isLoading, error, isSubmitting, showSuccessAlert, loadForm, handleSubmit, resetForm, FormBuilder, FormSuccess, FormError, FormLoading }
}

})